import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import MuiListItemText from "@material-ui/core/ListItemText";
import classNames from "classnames";
import { makeStyles } from "../Utilities/ThemeHelper";
const useStyles = makeStyles(theme => ({
  root: {
    overflowWrap: "break-word"
  }
}));
export const ListItemText = props => {
  const {
    className,
    ...otherProps
  } = props;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(MuiListItemText, _extends({}, otherProps, {
    className: classNames("prmbl-listItemText", className, classes.root)
  }));
};
export default ListItemText;